(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["golf-shopping"] && !Shopify.designMode) return;
  try {
    (() => {
  const shop = document.getElementById('beese-golf-shop');
  if (!shop) return;
  const links = Array.from(shop.querySelectorAll('[data-category]'));
  const items = Array.from(shop.querySelectorAll('[data-product-category]'));
  const count = shop.querySelector('.bt-count');
  function filter(category) {
    if (!links.some(link => link.dataset.category === category)) category = 'all';
    let visible = 0;
    items.forEach(item => {
      item.hidden = category !== 'all' && item.dataset.productCategory !== category;
      if (!item.hidden) visible++;
    });
    links.forEach(link => {
      if (link.dataset.category === category) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
    count.textContent = visible + (visible === 1 ? ' product' : ' products');
  }
  links.forEach(link => link.addEventListener('click', event => {
    event.preventDefault();
    const category = link.dataset.category;
    history.replaceState(null, '', '#' + category);
    filter(category);
  }));
  window.addEventListener('hashchange', () => filter(location.hash.slice(1)));
  filter(location.hash.slice(1) || 'all');
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ornaments-shopping"] && !Shopify.designMode) return;
  try {
    (() => {
  const shop = document.getElementById('beese-ornament-shop');
  if (!shop) return;
  const links = Array.from(shop.querySelectorAll('[data-category]'));
  const items = Array.from(shop.querySelectorAll('[data-product-category]'));
  const count = shop.querySelector('.bt-count');
  function filter(category) {
    if (!links.some(link => link.dataset.category === category)) category = 'all';
    let visible = 0;
    items.forEach(item => {
      item.hidden = category !== 'all' && item.dataset.productCategory !== category;
      if (!item.hidden) visible++;
    });
    links.forEach(link => {
      if (link.dataset.category === category) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
    count.textContent = visible + (visible === 1 ? ' product' : ' products');
  }
  links.forEach(link => link.addEventListener('click', event => {
    event.preventDefault();
    const category = link.dataset.category;
    history.replaceState(null, '', '#' + category);
    filter(category);
  }));
  window.addEventListener('hashchange', () => filter(location.hash.slice(1)));
  filter(location.hash.slice(1) || 'all');
})();
  } catch(e) { console.error(e); }
})();

})();
